import { useApi } from '@backstage/frontend-plugin-api';
import { translateStatus } from '@ipen-portal/plugin-common';
import { useQuery } from '@tanstack/react-query';

import { productStatusMonitoringApiRef } from '../apis';

export const usePlatformStatus = () => {
  const api = useApi(productStatusMonitoringApiRef);
  const { data } = useQuery(api.getPlatformStatus.queryOptions());
  return translateStatus(data);
};
